import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/app'
import './styles/styles.scss'

ReactDOM.render(<App />, document.getElementById('root'))
